import { render, staticRenderFns } from "./StudentCertificate.vue?vue&type=template&id=0d61a093&scoped=true"
import script from "./StudentCertificate.vue?vue&type=script&lang=js"
export * from "./StudentCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d61a093",
  null
  
)

export default component.exports